import ShippingItemAutocomplete from './ShippingItemAutocomplete'

export default ShippingItemAutocomplete
